import { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import AdminLayout from "@/pages/admin/AdminLayout";
import { ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { LeadInfoPanel } from "@/components/admin/LeadInfoPanel";
import { LeadActionsPanel } from "@/components/admin/LeadActionsPanel";

export default function LeadDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [lead, setLead] = useState(null);
  const [meta, setMeta] = useState({ statuses: [] });
  const [note, setNote] = useState("");
  const [assignee, setAssignee] = useState("");

  const load = useCallback(
    () => api.get(`/admin/leads/${id}`).then((r) => { setLead(r.data); setAssignee(r.data.assigned_to || ""); }),
    [id]
  );
  useEffect(() => { load(); api.get("/admin/meta").then((r) => setMeta(r.data)); }, [load]);

  if (!lead) return <AdminLayout><div className="text-[#9aa6c0]">Chargement…</div></AdminLayout>;

  const setStatus = async (status) => {
    const { data } = await api.patch(`/admin/leads/${id}/status`, { status });
    setLead(data); toast.success(`Statut : ${status}`);
  };
  const addNote = async () => {
    if (!note.trim()) return;
    const { data } = await api.post(`/admin/leads/${id}/notes`, { text: note });
    setLead(data); setNote(""); toast.success("Note ajoutée");
  };
  const assign = async () => {
    const { data } = await api.patch(`/admin/leads/${id}/assign`, { assigned_to: assignee });
    setLead(data); toast.success("Lead assigné");
  };
  const copyScript = () => { navigator.clipboard.writeText(lead.call_script); toast.success("Script copié"); };

  return (
    <AdminLayout>
      <button onClick={() => navigate("/admin")} data-testid="back-to-leads"
        className="inline-flex items-center gap-2 text-[#4b5b7c] font-semibold hover:text-[#1a2d56] mb-5">
        <ArrowLeft size={18} /> Retour aux leads
      </button>

      <div className="grid lg:grid-cols-3 gap-6">
        <LeadInfoPanel lead={lead} onCopyScript={copyScript} />
        <LeadActionsPanel
          lead={lead}
          meta={meta}
          note={note}
          setNote={setNote}
          assignee={assignee}
          setAssignee={setAssignee}
          onSetStatus={setStatus}
          onAddNote={addNote}
          onAssign={assign}
          reload={load}
        />
      </div>
    </AdminLayout>
  );
}
